import { ViewCommon } from "components/index";
import styled from "styled-components";

export const Container = styled(ViewCommon)`
    margin-bottom: 65px
`;

export const View = styled(ViewCommon)`
 `;